export default __webpack_public_path__ + "static/media/volvo.203b23b1.svg";